export const T = {
  en_GB: { label: "Breadcrumb" },
  nb_NO: { label: "Brødsmulesti" },
} as const;
